<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';

  export default Vue.extend({
    name: 'LDViewCriteria',
    data() {
      return {
        criteria: null
      };
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion']),
    },
    methods: {
      onMounting: async function() {
        if (this.getCurrentDiscussion) {
          this.criteria = this.getCurrentDiscussion.points_settings.peer_rewards;
        }
      }
    },
    mounted: async function() {
      const { onMounting } = this;
      await onMounting();
    }
  });
</script>
<template>
  <pl-dialog :disableOutsideClick="true" size="sequence_size" title="Assessment Criteria" @close="$emit('close')">
    <div v-if="criteria" class="flex flex-col space-y-3 overflow-y-auto h-full pb-6 px-6">
      <div v-for="(cr, index) in criteria" :key="index" class="flex flex-col space-y-2 bg-gray-100 border border-solid border-gray-200 rounded px-4 py-3">
        <div class="flex flex-col space-y-2 mb-3">
          <h6 class="font-poppins text-gray-800 font-semibold">{{ cr.title }}</h6>
          <span v-if="Array.isArray(cr.description)">{{ cr.description[0] }}</span>
          <div v-else>
            <div v-html="cr.description"></div>
          </div>
          
        </div>
        <div v-if="cr.points_description && cr.points_description.length > 0 && getCurrentDiscussion.point_cap !== null">
          <div v-for="(point_desc) in cr.points_description">
            <div v-if="point_desc.description !== ''" class="flex flex-col space-y-2 border border-solid border-gray-200 px-2 py-2 rounded bg-white space-x-2 mb-2">
              <div class="flex items-center space-x-2">
                <div class="border bg-gray-100 font-poppins border-solid space-x-2 border-gray-200 flex px-2.5 items-center w-full h-7 rounded">
                  <span class="font-poppins text-sm">Level</span>
                  <span>{{ point_desc.value }}</span>
                </div>
              </div>
              <div class="font-poppins text-sm text-gray-700">
                {{ point_desc.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>



// WEBPACK FOOTER //
// LDViewCriteria.vue?6b4f15a6